import React from "react";
import PropTypes from "prop-types";
import { NavButton, NavRoot } from "./elements";

const ChevronLeft = () => (
	<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path
			d="M12.5 15L7.5 10L12.5 5"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const ChevronRight = () => (
	<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path
			d="M7.5 5L12.5 10L7.5 15"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const BettoWalletNavigation = ({ children }) => <NavRoot>{children}</NavRoot>;

export const BettoWalletNavButton = ({
	direction,
	onClick,
	disabled,
	active,
	testId,
}) => (
	<NavButton
		type="button"
		data-testid={testId}
		onClick={onClick}
		disabled={disabled}
		$active={active}
		$primary={direction === "forward"}>
		{direction === "back" ? <ChevronLeft /> : <ChevronRight />}
	</NavButton>
);

BettoWalletNavigation.propTypes = {
	children: PropTypes.node,
};

BettoWalletNavButton.propTypes = {
	direction: PropTypes.oneOf(["back", "forward"]).isRequired,
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	active: PropTypes.bool,
	testId: PropTypes.string,
};

BettoWalletNavButton.defaultProps = {
	onClick: undefined,
	disabled: false,
	active: true,
	testId: undefined,
};
